/* ==========================================================================
   Kaikan Cards — Categorieën, bento

   Twee taken, allebei met een IntersectionObserver en geen scroll-listener:

   1. Entree. Het script zet zelf .js-animeer op het raster (pas dan verstopt
      de CSS de tegels) en haalt ze met .is-in weer tevoorschijn zodra het
      raster in beeld komt. Zo staat de navigatie er gewoon als dit script
      niet laadt — verstoppen in de CSS en hopen dat JS het aanzet levert een
      onzichtbaar menu op zodra er iets hapert.

      Daar hoort een noodrem bij: vuurt de waarnemer binnen 1,5 seconde niet
      (een tab die niet tekent levert geen frames, en zonder frames geen
      callback), dan gaan de tegels alsnog aan.

   2. Video. Een tegelvideo krijgt zijn src pas bij het eerste zicht — zet je
      hem in de HTML, dan laadt een telefoon tien filmpjes die niemand ziet.
      In beeld: spelen. Eruit: pauzeren en de foto terug, zodat er nooit meer
      dan een handvol video's tegelijk draait.

   Video uit bij prefers-reduced-motion en bij databesparing.
   ========================================================================== */
(function () {
  'use strict';

  var rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var heeftIO = 'IntersectionObserver' in window;

  function zuinig() {
    var n = navigator.connection;
    if (!n) return false;
    return n.saveData === true || /(^|-)2g$/.test(n.effectiveType || '');
  }

  function start(wortel) {
    if (!wortel || wortel.dataset.kkcatKlaar === '1') return;
    wortel.dataset.kkcatKlaar = '1';

    var raster = wortel.querySelector('.kkcat__grid');
    if (!raster) return;

    var kijkers = [];

    /* ---- entree ---- */
    if (!rustig && heeftIO) {
      raster.classList.add('js-animeer');

      var aan = function () {
        raster.classList.add('is-in');
        clearTimeout(noodrem);
        io.disconnect();
      };
      var noodrem = setTimeout(aan, 1500);
      var io = new IntersectionObserver(function (regels) {
        for (var i = 0; i < regels.length; i++) {
          if (regels[i].isIntersecting) { aan(); return; }
        }
      }, { rootMargin: '0px 0px -8% 0px' });
      io.observe(raster);
      kijkers.push(io);
    }

    /* ---- video ---- */
    var films = wortel.querySelectorAll('.kkcat__video');
    var mag = wortel.dataset.video === 'aan';

    if (films.length && mag && !rustig && !zuinig() && heeftIO) {
      var iov = new IntersectionObserver(function (regels) {
        regels.forEach(function (r) {
          var v = r.target;
          var kaart = v.closest('.kkcat__kaart');
          if (r.isIntersecting) {
            if (!v.getAttribute('src') && v.dataset.bron) {
              v.setAttribute('src', v.dataset.bron);
            }
            v.addEventListener('playing', function () {
              if (kaart) kaart.classList.add('is-video');
            }, { once: true });
            var p = v.play();
            if (p && p.catch) p.catch(function () { /* autoplay geweigerd: foto blijft staan */ });
          } else {
            v.pause();
            if (kaart) kaart.classList.remove('is-video');
          }
        });
      }, { threshold: 0.35 });

      Array.prototype.forEach.call(films, function (v) { iov.observe(v); });
      kijkers.push(iov);
    }

    /* Thema-editor: sectie eruit = kijkers los, anders blijven ze hangen. */
    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target.contains(wortel)) return;
      kijkers.forEach(function (k) { k.disconnect(); });
    });
  }

  function alles() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-kkcat]'), start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alles);
  } else {
    alles();
  }

  document.addEventListener('shopify:section:load', alles);
})();
